import { Button, MenuItem, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { useGetSections } from "../../hooks/useGetSections";
import axios from "axios";
import "./Home.css";

const Home = ({ name, setName, fetchQuestions, section, setSection, quiz, setQuiz }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [quizNames, setQuizNames] = useState("");
  const [sections, setSections] = useState();
  const { sectionData } = useGetSections();
  const [clicked, setClicked] = useState(false);

  const history = useHistory();

  const handleSubmit = async () => {
    if (!section || !quiz || !name || !password) {
      setError(true);
      setClicked(false);
      setErrorMsg('Please fill all the fields')
      return;
    } else {
      setError(false);
      setClicked(true);
      const quizAuth = await fetchQuestions(name, quiz, section, password);
      if (quizAuth?.error) {
        setError(true);
        setErrorMsg(quizAuth?.message);
        return;
      }
      history.push("/quiz");
    }
  };

  useEffect(() => {
    setSections(sectionData);
  }, [sectionData]);

  useEffect(() => {
    const fetchQuizNames = async (section) => {
      try {
        const url = 'https://computer-quiz-backend.herokuapp.com/quizzes/list';
        const { data } = await axios.get(url + `${section && `?year_section=${section}`}`);
        setQuizNames(data);
      } catch (error) {
        setError(error.message);
      }
    };
      if (sections && section) {
        fetchQuizNames(section);
      }
    }, [sections, section]);

  return (
    <div className="content">
      <div className="settings">
        <span style={{ fontSize: 30 }}>Quiz Settings</span>
        <div className="settings__select">
          { error && <ErrorMessage>{errorMsg}</ErrorMessage> }
          <TextField
            style={{ marginBottom: 25 }}
            label="Enter your full name here ex: (BGallardo, Romel T.)"
            variant="outlined"
            onChange={(e) => setName(e?.target?.value)}
          />
          { sections &&
            <TextField
              select
              label="Select Section"
              value={section}
              onChange={(e) => setSection(e?.target?.value)}
              variant="outlined"
              style={{ marginBottom: 30 }}
            >
              {sections.map((cat) => (
                <MenuItem
                  key={cat.year_section}
                  value={cat._id}
                >
                  {cat.year_section}
                </MenuItem>
              ))}
            </TextField>
          }
          { section  && 
            <TextField
              select
              label="Select a Quiz"
              value={quiz}
              onChange={(e) => setQuiz(e?.target?.value)}
              variant="outlined"
              style={{ marginBottom: 30 }}
            >
              {quizNames && quizNames.map((q) => (
                <MenuItem
                  key={q._id}
                  value={q._id}
                >
                  {q.quiz_name}
                </MenuItem>
              ))}
            </TextField>
          }
          {quiz && 
            <TextField
              style={{ marginBottom: 25 }}
              label="Enter Quiz Password"
              variant="outlined"
              type="password"
              onChange={(e) => setPassword(e?.target?.value)}
            />
          }
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
            disabled={clicked}
          >
            Start Quiz
          </Button>
        </div>
      </div>
      <img src="/image.png" className="banner" alt="quiz app" />
    </div>
  );
};

export default Home;
